export default __webpack_public_path__ + "static/media/23.0e3947d7.png";